/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FeatureWebpage } from "./feature-webpage";

const FeatureWebpageComponent = (props) => {

    const component = props?.component;
    const webpageCard = component?.webpageCard ?? "";
    const webpages = component?.webpages ?? [];

    return (
        <div className={`feature-webpage-container ${webpageCard}_${webpages.length}`}>
            {webpages?.length > 0 && (
                <>
                    {webpages.map((webpage, idx) => (
                        <FeatureWebpage
                            key={idx}
                            idx={idx}
                            webpage={webpage}
                            webpageCard={webpageCard}
                            total={webpages.length}
                        />
                    ))}
                </>
            )}
        </div>
    );
};

FeatureWebpageComponent.displayName = "FeatureWebpageComponent";
export { FeatureWebpageComponent };
